import { Variable } from "@/components/InputVariableConfigurator/types";

export const getVariableValue = (variable: Variable) => {
  return typeof variable.value === "object"
    ? JSON.stringify(variable.value)
    : String(variable.value);
};
